import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=cfbaffd2&"
import script from "./CreateRole.js?vue&type=script&lang=js&"
export * from "./CreateRole.js?vue&type=script&lang=js&"
import style0 from "./CreateRole.vue?vue&type=style&index=0&id=cfbaffd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports